import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/store';
import DynamicTableComponent from '../../DynamicTable/DynamicTableComponent';
import { ReceivingDelivery } from './../../../app/models/ReceivingDelivery';

function DashboardReceivingTableData() {
  const { receivingdeliveryStore, dashboardStore, commonStore } = useStore();
  const { userReadableDateFormat } = commonStore;
  const {
    receivingsdeliveries,
    loadReceivingsDeliveriesPagination,
    loading,
    loadingInitial,
    loadingInitialReceiving,
  } = receivingdeliveryStore;
  // const [pageNumber,setPageNumber]=useState(1);
  const [pageNumber, setPageNumber] = useState(
    dashboardStore.dashboard.setRegisterPageNumber,
  );
  const [tableData, setTableData] = useState<ReceivingDelivery[]>([]);

  useEffect(() => {
    loadReceivingsDeliveriesPagination(1);
    dashboardStore.receivingCount();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    setPageNumber(dashboardStore.dashboard.setRegisterPageNumber);
  }, [dashboardStore.dashboard.setRegisterPageNumber]);

  useEffect(() => {
    if (receivingsdeliveries.length > 0) {
      const tempData: ReceivingDelivery[] = [];
      receivingsdeliveries.forEach((a) => {
        tempData?.push({
          ...a,
          date: userReadableDateFormat(a.date),
        });
      });
      const removeCol =
        'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost';
      const RegisterTable = JSON.parse(JSON.stringify(tempData));
      RegisterTable.map((i: any) =>
        removeCol.split(',').map((j) => delete i[j]),
      );
      setTableData(RegisterTable);
    }
  }, [receivingsdeliveries, userReadableDateFormat]);

  if (!loadReceivingsDeliveriesPagination || loading || loadingInitialReceiving)
    return <LoadingComponent />;

  const paginateFunction = (e: number) => {
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      receivingdeliveryStore.searchListReceiving(
        e,
        dashboardStore.dashboard.searchfilterparams,
      );
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      receivingdeliveryStore.sortReceivingList(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        e,
      ); //api call
      // activityStore.sortListTag(dashboardStore.dashboard.orderName,dashboardStore.dashboard.orderData,e);//api call
    } else {
      loadReceivingsDeliveriesPagination(e);
    }
    dashboardStore.setRegisterPageNum(e);

    setPageNumber(e);
  };

  // if (loadingInitial) return <LoadingComponent />;
  return (
    <div>
      <DynamicTableComponent
        data={tableData}
        name={'ReceivingTable'}
        actiontype={'editdel'}
        pageFunc={paginateFunction}
        setPageNumber={setPageNumber}
        pageNumData={pageNumber}
        searchFuncData={''}
        loading={loadingInitial}
      />
    </div>
  );
}

export default observer(DashboardReceivingTableData);
